import * as api from '../api';

export const GET_PROJECT_EXPENSES = 'GET_PROJECT_EXPENSES';
export const GET_PROJECT_EXPENSE = 'GET_PROJECT_EXPENSE';
export const CREATE_PROJECT_EXPENSE = 'CREATE_PROJECT_EXPENSE';
export const UPDATE_PROJECT_EXPENSE = 'UPDATE_PROJECT_EXPENSE';
export const DELETE_PROJECT_EXPENSE = 'DELETE_PROJECT_EXPENSE';

export const getProjectExpenses = (searchQuery, page, pageSize) => async (dispatch) => {
  try {
    const { data } = await api.fetchProjectExpenses(searchQuery, page, pageSize);
    dispatch({ type: GET_PROJECT_EXPENSES, payload: data });
    return data;
  } catch (error) { console.error('Error fetching project expenses:', error); throw error; }
};

export const createProjectExpense = (expenseData) => async (dispatch) => {
  try {
    const { data } = await api.createProjectExpense(expenseData);
    dispatch({ type: CREATE_PROJECT_EXPENSE, payload: data });
    return data;
  } catch (error) { console.error('Error creating project expense:', error); throw error; }
};

export const updateProjectExpense = (id, expenseData) => async (dispatch) => {
  try {
    const { data } = await api.updateProjectExpense(id, expenseData);
    dispatch({ type: UPDATE_PROJECT_EXPENSE, payload: data });
    return data;
  } catch (error) { console.error('Error updating project expense:', error); throw error; }
};

export const deleteProjectExpense = (id) => async (dispatch) => {
  try {
    await api.deleteProjectExpense(id);
    dispatch({ type: DELETE_PROJECT_EXPENSE, payload: id });
  } catch (error) { console.error('Error deleting project expense:', error); throw error; }
};
